import {
  EmailFooterDataListInterface,
  EmailFooterUpdateInterface,
} from 'shared/components/dashboard-mail-editor/types/email-footer-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { handle422Error } from 'shared/utils/parse-422-errors'
import { MailingSettingsErrorsInterface } from '../types/mailing-settings-interface'

export const useUpdateEmailFooter = () => {
  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.put, EmailFooterDataListInterface>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: error => {
      throw error
    },
  })

  return {
    fetcher: async (
      data: EmailFooterUpdateInterface,
      setErrors: (value: React.SetStateAction<MailingSettingsErrorsInterface>) => void,
    ) => {
      try {
        return await fetcher(`/api/dashboard/mailing-service/email-footer`, data)
      } catch (e) {
        handle422Error(e, setErrors)
        throw e
      }
    },
    isFetching,
  }
}
